// extracted by mini-css-extract-plugin
export default {"category":"category_category__YTGkp","active":"category_active__7gOP-","info":"category_info__pJ-6P","fact":"category_fact__GveJU"};